import Notification from '@rio-cloud/rio-uikit/Notification';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { useCallback, useId, useState } from 'react';

import { useSetupPaymentMethodMutation } from '../api/billing/paymentApiSlice';

export const BankTransferPanel = () => {
    const [accountId, setAccountId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const tooltipId = useId();
    const inputId = useId();
    const [setupPaymentMethod] = useSetupPaymentMethodMutation();

    const onAssign = useCallback(() => {
        setIsSubmitting(true);
        setupPaymentMethod({ accountId, body: { payment_type: 'BANK_TRANSFER' } })
            .unwrap()
            .then(() => {
                Notification.success('Bank transfer has been enabled to the customer.');
                setAccountId('');
            })
            .catch((error: unknown) => {
                const e = error as any;
                const message = e?.data?.title ?? e?.data?.error ?? e?.message ?? 'Unknown error';
                Notification.error(`Failed to assign bank transfer: ${message}`);
            })
            .finally(() => setIsSubmitting(false));
    }, [accountId, setupPaymentMethod]);

    return (
        <div className='panel panel-warning'>
            <div className='panel-heading'>
                <div className='display-flex align-items-center'>
                    <span className='margin-right-5'>Bank transfer payment method</span>
                    <OverlayTrigger
                        placement={'right'}
                        overlay={
                            <Tooltip id={`bank-transfer-help-${tooltipId}`} allowOnTouch>
                                Assigns the bank transfer payment method. "Payment on invoice" must be set in
                                Salesforce.
                            </Tooltip>
                        }
                    >
                        <span className='uikit-icon icon-info-sign text-color-info cursor-help' />
                    </OverlayTrigger>
                </div>
            </div>
            <div className='panel-body'>
                <div className='display-flex align-items-end'>
                    <div className='flex-grow-1 margin-right-10'>
                        <label htmlFor={inputId} className='form-label'>
                            Account ID
                        </label>
                        <input
                            id={inputId}
                            className='form-control'
                            type='text'
                            placeholder='Enter accountId'
                            value={accountId}
                            onChange={e => setAccountId(e.target.value)}
                            disabled={isSubmitting}
                            style={{ width: '44ch' }}
                        />
                    </div>
                    <button
                        type='button'
                        className='btn btn-primary margin-left-10'
                        onClick={onAssign}
                        disabled={!accountId.trim() || isSubmitting}
                    >
                        {isSubmitting ? 'Enabling…' : 'Enable bank transfer'}
                    </button>
                </div>
            </div>
        </div>
    );
};
